import React from 'react';
import { Flex, Text, Heading, Divider, View } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '../../utils/utils';

export default function SiteFooter() {
	const { t } = useTranslation('app');

	return (
		<View as="footer" backgroundColor="#1a1a2e" padding="48px 24px 24px">
			<Flex
				maxWidth="1200px"
				margin="0 auto"
				direction={{ base: 'column', medium: 'row' }}
				gap="40px"
				justifyContent="space-between"
			>
				{/* Brand */}
				<Flex direction="column" gap="8px" maxWidth="300px">
					<Heading level={4} color="white" fontWeight="700">
						{APP_NAME}
					</Heading>
					<Text color="rgba(255,255,255,0.6)" fontSize="14px">
						{t('footer.tagline')}
					</Text>
				</Flex>

				{/* Company links */}
				<Flex direction="column" gap="8px">
					<Text color="rgba(255,255,255,0.4)" fontSize="12px" fontWeight="600" textTransform="uppercase">
						{t('footer.company')}
					</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.aboutUs')}</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.careers')}</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.contact')}</Text>
				</Flex>

				{/* Legal links */}
				<Flex direction="column" gap="8px">
					<Text color="rgba(255,255,255,0.4)" fontSize="12px" fontWeight="600" textTransform="uppercase">
						{t('footer.legal')}
					</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.privacyPolicy')}</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.termsOfService')}</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.legalDisclosures')}</Text>
				</Flex>

				{/* Social */}
				<Flex direction="column" gap="8px">
					<Text color="rgba(255,255,255,0.4)" fontSize="12px" fontWeight="600" textTransform="uppercase">
						{t('footer.connect')}
					</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.twitter')}</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.linkedin')}</Text>
					<Text color="rgba(255,255,255,0.7)" fontSize="14px">{t('footer.email')}</Text>
				</Flex>
			</Flex>

			<Divider margin="32px auto 16px" maxWidth="1200px" opacity="0.2" />

			<Flex
				maxWidth="1200px"
				margin="0 auto"
				direction="column"
				gap="12px"
				padding="0 0 8px"
			>
				<View
					backgroundColor="rgba(255,255,255,0.08)"
					padding="12px 16px"
					borderRadius="8px"
					border="1px solid rgba(255,255,255,0.12)"
				>
					<Text color="rgba(255,255,255,0.7)" fontSize="12px" fontWeight="600" lineHeight="1.5">
						{t('footer.noOfferDisclaimer')}
					</Text>
				</View>
				<Text color="rgba(255,255,255,0.4)" fontSize="11px" lineHeight="1.6">
					{t('footer.disclaimer')}
				</Text>
				<Text color="rgba(255,255,255,0.3)" fontSize="11px">
					{t('footer.copyright')}
				</Text>
			</Flex>
		</View>
	);
}
